import SEO, { breadcrumbSchema, faqSchema } from "../components/SEO";
import PageHero from "../components/PageHero";
import CtaBand from "../components/CtaBand";
import FaqAccordion from "../components/FaqAccordion";
import { SectionHead } from "../components/Cards";
import { FAQS } from "../data/content";
import { IMAGES } from "../data/site";

export default function Faq() {
  return (
    <>
      <SEO
        title="FAQs — Taxi Booking in Jodhpur & Rajasthan"
        description="Answers about booking a taxi in Jodhpur: one-way cabs, airport pickup, Rajasthan sightseeing, outstation trips, family vehicles and how to get the latest fare."
        path="/faq"
        schemas={[
          breadcrumbSchema([{ name: "Home", path: "/" }, { name: "FAQ", path: "/faq" }]),
          faqSchema(FAQS),
        ]}
      />
      <PageHero
        title="Frequently Asked Questions"
        subtitle="Everything travellers usually ask before booking a taxi with us in Jodhpur and across Rajasthan."
        image={IMAGES.jaipur}
        crumbs={[{ label: "Home", to: "/" }, { label: "FAQ" }]}
      />
      <section className="max-w-3xl mx-auto px-6 py-16">
        <SectionHead eyebrow="Good to Know" title="Before You Book" />
        <div className="mt-8 bg-white rounded-2xl border border-slate-200/80 px-6">
          <FaqAccordion faqs={FAQS} idPrefix="faq-page" />
        </div>
      </section>
      <CtaBand title="Still have a question?" text="Ask us directly on WhatsApp — a real person from Jodhpur answers, not a bot." />
    </>
  );
}
